import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeDocument } from '../../../shared/models/jobTypeDocument.model';

// import { CreateJobTypeComponent} from './create-job-type.component';

import { BsModalService } from 'ngx-bootstrap/modal';
import { JobType } from '../../../shared/models/jobType.model';
import { SystemLogType } from 'src/app/shared/models/systemLogType.model';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { SystemLogTypeDataSectorCondition } from 'src/app/shared/models/systemLogTypeDataSectorCondition.model';

@Component({
  selector: 'app-system-log-type-data-sector-condition-create',
  templateUrl: './system-log-type-data-sector-condition-create.component.html',
  styleUrls: ['./system-log-type-data-sector-condition-create.component.scss']
})
export class SystemLogTypeDataSectorConditionCreateComponent implements OnInit {


  model: SystemLogTypeDataSectorCondition;
  job_types: Object;
  job_type_locations: Object;
  count2: any;
  get_latest_court_id: Object;
  job_type_courts: Object;
  sent_job_type_location_id: any;
  get_latest_document_id: Object;
  job_type_affidavit_types: Object;
  sent_job_type_document_type_id: any;
  get_latest_type_id: any;

  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef,
    public gfunc: GlobalFunctionsService
  ) { }

  ngOnInit() {
    this.model = new SystemLogTypeDataSectorCondition();
    
  }



  createSystemLogType(model) {
    // console.log(model);
        this._demoService.createSystemLogType(model).subscribe(
             data => {  this.get_latest_type_id = data; // this is the retuned json upon creation.
             this.toastr.success('Log Type Created');
             this.closeParentModel.emit();
             this.gfunc.globalViewSystemLogTypesSkipRoute();
   // CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Job Type Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
             }
        );
        }
 
 
        createSystemLogTypeDataSectorCondition(model) {
          // console.log(model);
              this._demoService.createSystemLogTypeDataSectorCondition(model).subscribe(
                   data => {  this.get_latest_type_id = data; // this is the retuned json upon creation.
                   this.toastr.success('Log Type Data Sector Condition Created');
                   this.closeParentModel.emit();
                   this.gfunc.globalViewSystemLogTypeDataSectorConditionsSkipRoute();
         // CreateJobTypeComponent.returned.next(false);
                     //  return true;
                   },
                   error => {
                     this.toastr.error('Adding Log Type Data Sector Condition Failed :: Please try again!');
                     // console.log(Observable.throw(error));
                     // return Observable.throw(error);
                   }
              );
              }
       


  createJobType(model) {
    // console.log(model);
        this._demoService.createJobType(model).subscribe(
             data => {  this.get_latest_type_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */

             this.closeParentModel.emit();
   // CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Job Type Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
             }
        );
        }
 
 
        traceAddNotice () {
         this.toastr.info('Job Type Added');
       };
 



}
